import {TFunction} from "i18next";

export const enum SUPPORT_REQUESTS_TABLE_COLUMN {
  ID = 'requestId',
  REQUEST = 'request',
  SETTINGS = 'settings',
  STATUS = 'status',
}

export const SUPPORT_REQUESTS_ACTIVE_COLUMNS: SUPPORT_REQUESTS_TABLE_COLUMN[] = [
  SUPPORT_REQUESTS_TABLE_COLUMN.REQUEST,
  SUPPORT_REQUESTS_TABLE_COLUMN.STATUS,
  SUPPORT_REQUESTS_TABLE_COLUMN.ID,
  SUPPORT_REQUESTS_TABLE_COLUMN.SETTINGS,
]

export const getColumnName = (columnId: SUPPORT_REQUESTS_TABLE_COLUMN, t: TFunction) => {
  switch (columnId) {
    case SUPPORT_REQUESTS_TABLE_COLUMN.REQUEST:
      return t('support__text__requestTableRequest')
    case SUPPORT_REQUESTS_TABLE_COLUMN.STATUS:
      return t('support__text__requestTableStatus')
    case SUPPORT_REQUESTS_TABLE_COLUMN.ID:
      return t('support__text__requestTableId')
    default:
      return ''
  }
}
